export const mock = {
    nav: [
        { genrs: 'action' },
        { genrs: 'adventure' },
        { genrs: 'animation' },
        { genrs: 'biography' },
        { genrs: 'comedy' },
        { genrs: 'crime' },
        { genrs: 'drama' },
        { genrs: 'documentary' },
        { genrs: 'fantasy' },
        { genrs: 'family' },
        { genrs: 'history' },
        { genrs: 'horror' },
        { genrs: 'sport' },
        { genrs: 'Film-Noir' },
        { genrs: 'thriller' },
        { genrs: 'war' },
        { genrs: 'music' },
        { genrs: 'musical' },
        { genrs: 'mystery' },
        { genrs: 'romance' },
        { genrs: 'Sci-Fi' },
        { genrs: 'western' }
    ],
    header: [
        {
            navbar: 'Home',
            url: '/',
            icon:'bi bi-house'
        },
        {
            navbar: 'Browse Movies',
            url:'/browsermovies',
            icon:'bi bi-film'
        }
    ]
}